import { createFileRoute, redirect } from '@tanstack/react-router';
import { isAuthenticated, mustResetPassword } from '../auth/session';

export const Route = createFileRoute('/')({
  beforeLoad: () => {
    if (!isAuthenticated()) {
      throw redirect({ to: '/login' });
    }
    throw redirect({ to: mustResetPassword() ? '/change-password' : '/contests' });
  },
});
